// extracted by mini-css-extract-plugin
export default {"weekdays":"WeekDays_weekdays__uTIwU","weekday":"WeekDays_weekday__GnvV4"};